{
  "currencies": ["EUR", "USD", "GBP"],
  "interest": ["Converted", "Not Converted"],
  "solveFor": ["Yield", "Strike"],
  "tabs": [
    {
      "currency": "USD",
      "selected": true
    },
    {
      "currency": "SGD",
      "selected": false
    },
    {
      "currency": "NZD",
      "selected": false
    },
    {
      "currency": "AUD",
      "selected": false
    },
    {
      "currency": "JPY",
      "selected": false
    },
    {
      "currency": "CHF",
      "selected": false
    }
  ]
}
